import { createFileRoute } from "@tanstack/react-router";
import { DevPage } from "@/paginas/dev";

export const Route = createFileRoute("/_authenticated/dev")({
  head: () => ({
    meta: [
      { title: "Dev — Milky Moo Palmares" },
      {
        name: "description",
        content: "Ferramentas de desenvolvimento e diagnóstico do sistema.",
      },
      { property: "og:title", content: "Dev — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Ferramentas de desenvolvimento e diagnóstico do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: DevPage,
});
